import { useState } from "react";
import { api } from "../../js/api/messaging";
import { useAuth } from "../../js/hooks/useAuth";
import { buildReportModel, reportFileStem } from "../../js/export/reportModel";

export default function ExportButton({ transaction, onNotice }) {
  const { session, role } = useAuth();
  const [busy, setBusy] = useState(false);
  const allowed = role === "agent" || role === "broker" || role === "admin";

  if (!allowed || !transaction?.id) return null;

  async function handleExport() {
    setBusy(true);
    const result = await api("POST", `/api/transactions/${transaction.id}/export`, {}, session);
    if (!result.ok) {
      setBusy(false);
      onNotice?.(result.error || "Could not save a report.");
      return;
    }
    const payload = result.data?.payload || result.data;
    const model = buildReportModel(payload, {
      exportType: result.data?.export_type,
      generatedBy: session?.name,
    });
    const stem = reportFileStem(transaction.property_address);
    try {
      const { downloadReportPdf } = await import("../../js/export/reportPdf");
      downloadReportPdf(model, `dreamhome-${stem}-report.pdf`);
      onNotice?.("A communication report was saved as a PDF.");
    } catch {
      const html = result.data?.html;
      if (html) {
        const blob = new Blob([html], { type: "text/html" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `dreamhome-${stem}-report.html`;
        link.click();
        URL.revokeObjectURL(url);
        onNotice?.("A communication report was saved as HTML.");
      } else {
        onNotice?.("The report was stored, but the PDF could not be downloaded.");
      }
    } finally {
      setBusy(false);
    }
  }

  return (
    <button type="button" className="ghost-btn export-btn" onClick={handleExport} disabled={busy}>
      {busy ? "Preparing…" : "Save report"}
    </button>
  );
}
